/* VANOPRIME — PawVest Shopify store logic: cursor, cart (Shopify API), drawer, scroll, product page */
(function () {
  const STORE = window.STORE;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------------- custom cursor ---------------- */
  const ring = document.createElement('div'); ring.className = 'cursor-ring';
  const dot = document.createElement('div'); dot.className = 'cursor-dot';
  document.body.append(ring, dot);
  let mx = innerWidth / 2, my = innerHeight / 2, rx = mx, ry = my;
  addEventListener('mousemove', (e) => { mx = e.clientX; my = e.clientY; dot.style.transform = `translate(${mx}px,${my}px)`; });
  (function loop() { rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18; ring.style.transform = `translate(${rx}px,${ry}px)`; requestAnimationFrame(loop); })();
  const hoverSel = 'a,button,input,.cell-img,.rail-card,.thumb,.swatch-btn,.size-btn';
  document.addEventListener('mouseover', (e) => { if (e.target.closest(hoverSel)) document.body.classList.add('hovering'); });
  document.addEventListener('mouseout', (e) => { if (e.target.closest(hoverSel)) document.body.classList.remove('hovering'); });
  addEventListener('mousedown', () => document.body.classList.add('pressing'));
  addEventListener('mouseup', () => document.body.classList.remove('pressing'));

  /* ---------------- nav + progress + parallax ---------------- */
  const nav = $('.nav'); const prog = $('.progress'); const heroImg = $('.hero-bg img');
  function onScroll() {
    const y = scrollY;
    if (nav) nav.classList.toggle('scrolled', y > 40);
    if (prog) { const h = document.documentElement.scrollHeight - innerHeight; prog.style.width = (y / h * 100) + '%'; }
    if (heroImg && y < innerHeight) heroImg.style.transform = `translateY(${y * 0.32}px) scale(1.05)`;
    $$('[data-parallax]').forEach(el => { const s = parseFloat(el.dataset.parallax); const r = el.getBoundingClientRect(); const off = (r.top + r.height / 2 - innerHeight / 2); el.style.transform = `translateY(${off * s}px)`; });
  }
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---------------- scroll reveal ---------------- */
  const io = new IntersectionObserver((ents) => {
    ents.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  $$('.reveal').forEach(el => io.observe(el));

  /* ---------------- Shopify cart API ---------------- */
  async function shopifyAddToCart(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Array.isArray(items) ? { items } : { items: [items] })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  async function shopifyGetCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function shopifyChangeQty(lineItemKey, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItemKey, quantity })
    });
    await refreshCart();
  }

  async function refreshCart() {
    const cart = await shopifyGetCart();
    renderShopifyCart(cart);
  }

  function renderShopifyCart(cart) {
    const count = cart.item_count;
    $$('.cart-count').forEach(el => { el.textContent = count; el.classList.toggle('show', count > 0); });
    const body = $('.drawer-body'); if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = `<div class="drawer-empty"><div class="em">Your bag is empty.</div><p>Your pet is waiting — add PawVest™ and never leave them behind again.</p></div>`;
      if ($('.drawer-foot')) $('.drawer-foot').style.display = 'none';
      return;
    }
    if ($('.drawer-foot')) $('.drawer-foot').style.display = 'block';
    const money = (cents) => '£' + (cents / 100).toFixed(2);
    const sub = cart.items.reduce((a, it) => a + it.final_line_price, 0);
    const FREE_SHIP_CENTS = 4500;
    const remaining = FREE_SHIP_CENTS - sub;
    const shipNote = $('.ship-note');
    const shipBar = $('.ship-bar i');
    if (shipNote && shipBar) {
      if (sub >= FREE_SHIP_CENTS) {
        shipNote.innerHTML = '<b>You unlocked free shipping!</b>';
        shipBar.style.width = '100%';
      } else {
        shipNote.innerHTML = `Spend <b>${money(remaining)}</b> more for free shipping`;
        shipBar.style.width = Math.round((sub / FREE_SHIP_CENTS) * 100) + '%';
      }
    }
    body.innerHTML = cart.items.map(it => `
      <div class="line-item">
        <img src="${it.featured_image ? it.featured_image.url : ''}" alt="${it.title}">
        <div style="flex:1">
          <div class="li-t">${it.product_title}</div>
          <div class="li-v">${it.variant_title || ''}</div>
          <div class="qty" data-k="${it.key}">
            <button data-d="-1" aria-label="decrease">–</button><span>${it.quantity}</span><button data-d="1" aria-label="increase">+</button>
          </div>
        </div>
        <div class="li-right">
          <div class="li-price">${money(it.final_line_price)}</div>
          <button class="li-remove" data-rm="${it.key}">Remove</button>
        </div>
      </div>`).join('');
    $$('.qty[data-k]', body).forEach(el => {
      $$('button', el).forEach(btn => btn.addEventListener('click', async () => {
        const k = el.dataset.k;
        const item = cart.items.find(i => i.key === k);
        if (!item) return;
        await shopifyChangeQty(k, item.quantity + parseInt(btn.dataset.d));
      }));
    });
    $$('.li-remove[data-rm]', body).forEach(btn => btn.addEventListener('click', async () => {
      await shopifyChangeQty(btn.dataset.rm, 0);
    }));
    const sv = $('.sub-val'); if (sv) sv.textContent = money(sub);
    const tv = $('.tot-val'); if (tv) tv.textContent = money(sub);
  }

  /* ---------------- addToCart (Shopify) ---------------- */
  async function addToCart(variantId, quantity, extraItems) {
    try {
      let items = [{ id: variantId, quantity }];
      if (extraItems && extraItems.length) items = items.concat(extraItems);
      await shopifyAddToCart(items);
      await refreshCart();
      openDrawer();
      toast('Added to bag');
    } catch(e) { console.error(e); toast('Could not add to bag'); }
  }

  /* ---------------- findVariantId ---------------- */
  function findVariantId(colorKey, sizeLabel) {
    if (!window.SHOPIFY_VARIANTS) return null;
    const colorMap = { brown: 'Warm Brown', black: 'Midnight Black', orange: 'Sunset Orange' };
    const color = colorMap[colorKey] || colorKey;
    const size = sizeLabel.replace(/–/g, '-');
    const v = SHOPIFY_VARIANTS.find(v => v.color === color && v.size === size);
    return v ? v.id : null;
  }

  /* ---------------- drawer ---------------- */
  const scrim = $('.scrim'), drawer = $('.drawer');
  function openDrawer() { if (scrim) scrim.classList.add('open'); if (drawer) drawer.classList.add('open'); }
  function closeDrawer() { if (scrim) scrim.classList.remove('open'); if (drawer) drawer.classList.remove('open'); }
  $$('.cart-btn').forEach(b => b.onclick = openDrawer);
  if (scrim) scrim.onclick = closeDrawer;
  const dc = $('.drawer-close'); if (dc) dc.onclick = closeDrawer;
  addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  /* ---------------- mobile menu ---------------- */
  const mm = $('.mobile-menu'), mmToggle = $('.nav-toggle');
  const openMenu = () => mm && mm.classList.add('open');
  const closeMenu = () => mm && mm.classList.remove('open');
  if (mmToggle) mmToggle.onclick = openMenu;
  if (mm) {
    const mc = mm.querySelector('.mm-close'); if (mc) mc.onclick = closeMenu;
    mm.querySelectorAll('nav a').forEach(a => a.addEventListener('click', closeMenu));
    const mb = mm.querySelector('.mm-bag'); if (mb) mb.onclick = () => { closeMenu(); openDrawer(); };
  }

  /* ---------------- toast ---------------- */
  let toastEl, tTimer;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; document.body.appendChild(toastEl); }
    toastEl.innerHTML = `<span class="tk">&#10003;</span> ${msg}`;
    requestAnimationFrame(() => toastEl.classList.add('show'));
    clearTimeout(tTimer); tTimer = setTimeout(() => toastEl.classList.remove('show'), 2600);
  }

  /* ---------------- product page ---------------- */
  function initProduct() {
    if (!STORE || !STORE.product) return;
    const p = STORE.product;
    const state = { color: p.colors[0].key, size: p.sizes[0], qty: 1, img: 0 };
    const mainImg = $('#pdp-main'); const thumbs = $('#pdp-thumbs');
    const allImgs = [...p.gallery];
    function setMain(i) { state.img = i; mainImg.src = allImgs[i]; $$('.thumb', thumbs).forEach((t, ti) => t.classList.toggle('active', ti === i)); }
    if (thumbs) {
      thumbs.innerHTML = allImgs.map((g, i) => `<button class="thumb${i === 0 ? ' active' : ''}" data-i="${i}"><img src="${g}" alt="view ${i + 1}"></button>`).join('');
      $$('.thumb', thumbs).forEach(t => t.onclick = () => setMain(+t.dataset.i));
    }
    if (mainImg) mainImg.src = allImgs[0];

    // colors
    const swatchEl = $('#pdp-swatches');
    if (swatchEl) {
      swatchEl.innerHTML = p.colors.map((c, i) => `<button class="swatch-btn${i === 0 ? ' active' : ''}" data-c="${c.key}" style="--sw:${c.hex}" title="${c.label}"><span></span></button>`).join('');
      const colorLabel = $('#pdp-color-label');
      if (colorLabel) colorLabel.textContent = p.colors[0].label;
      $$('.swatch-btn').forEach(b => b.onclick = () => {
        state.color = b.dataset.c; $$('.swatch-btn').forEach(x => x.classList.remove('active')); b.classList.add('active');
        const c = p.colors.find(c => c.key === state.color); if (colorLabel) colorLabel.textContent = c.label;
        if (mainImg) mainImg.src = c.img; setMainActiveNone();
      });
    }
    function setMainActiveNone() { if (thumbs) $$('.thumb', thumbs).forEach(t => t.classList.remove('active')); }

    // sizes
    const sizesEl = $('#pdp-sizes');
    if (sizesEl) {
      sizesEl.innerHTML = p.sizes.map((s, i) => `<button class="size-btn${i === 0 ? ' active' : ''}" data-s="${s}">${s}</button>`).join('');
      $$('.size-btn').forEach(b => b.onclick = () => { state.size = b.dataset.s; $$('.size-btn').forEach(x => x.classList.remove('active')); b.classList.add('active'); const sw = $('#size-warn'); if (sw) sw.classList.remove('show'); });
    }

    // qty
    const qEl = $('#pdp-qty');
    const qDec = $('#q-dec'); const qInc = $('#q-inc');
    if (qDec) qDec.onclick = () => { state.qty = Math.max(1, state.qty - 1); if (qEl) qEl.textContent = state.qty; };
    if (qInc) qInc.onclick = () => { state.qty++; if (qEl) qEl.textContent = state.qty; };

    // add to cart
    const bumpEl = $('#bump-check');
    const CART_ICO = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
    const syncBtnText = () => {
      const addBtn = $('#pdp-add');
      if (!addBtn) return;
      if (bumpEl && bumpEl.checked) {
        addBtn.innerHTML = `${CART_ICO} Add Bundle to Bag — $65`;
      } else {
        addBtn.innerHTML = `${CART_ICO} Add to Bag — $${p.price.toFixed(0)}`;
      }
    };
    if (bumpEl) bumpEl.onchange = syncBtnText;

    const addBtn = $('#pdp-add');
    if (addBtn) {
      addBtn.onclick = () => {
        if (!state.size) { const sw = $('#size-warn'); if (sw) sw.classList.add('show'); return; }
        const vid = findVariantId(state.color, state.size);
        if (!vid) { toast('Please select size and color'); return; }
        let extras = [];
        if (bumpEl && bumpEl.checked && window.SHOPIFY_BOTTLE_VARIANT_ID) {
          extras.push({ id: window.SHOPIFY_BOTTLE_VARIANT_ID, quantity: 1 });
        }
        addToCart(vid, state.qty, extras);
      };
    }

    // "Get the Bundle" button in the kit section — scroll to size if not selected
    const bundleAddEl = document.getElementById('bundle-add');
    if (bundleAddEl) {
      bundleAddEl.onclick = (e) => {
        e.preventDefault();
        if (!state.size) {
          const grid = document.querySelector('.pdp-grid');
          if (grid) grid.scrollIntoView({ behavior: 'smooth' });
          const sw = $('#size-warn');
          if (sw) sw.classList.add('show');
          return;
        }
        if (bumpEl) { bumpEl.checked = true; syncBtnText(); }
        const vid = findVariantId(state.color, state.size);
        if (!vid) { toast('Please select size and color'); return; }
        addToCart(vid, state.qty, [{ id: window.SHOPIFY_BOTTLE_VARIANT_ID, quantity: 1 }]);
      };
    }

    // accordion (covers details + FAQ)
    $$('.acc-head').forEach(h => h.onclick = () => { const it = h.parentElement; it.classList.toggle('open'); });

    /* ---- countdown ---- */
    const cd = $('#countdown');
    if (cd) {
      let end = +localStorage.getItem('flou_cd');
      if (!end || end < Date.now()) { end = Date.now() + (23 * 3600 + 59 * 60 + 59) * 1000; localStorage.setItem('flou_cd', end); }
      const tick = () => {
        let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const h = String(Math.floor(s / 3600)).padStart(2, '0'); s %= 3600;
        const m = String(Math.floor(s / 60)).padStart(2, '0'); const ss = String(s % 60).padStart(2, '0');
        cd.innerHTML = `<i>${h}</i>h <i>${m}</i>m <i>${ss}</i>s`;
      };
      tick(); setInterval(tick, 1000);
    }

    /* ---- rating breakdown bars ---- */
    const rb = $('#rating-bars');
    if (rb && p.ratingBreakdown) {
      const bd = p.ratingBreakdown; const total = Object.values(bd).reduce((a, b) => a + b, 0);
      rb.innerHTML = [5, 4, 3, 2, 1].map(st => {
        const pct = (bd[st] / total * 100).toFixed(0);
        return `<div class="bar-row"><span>${st} ★</span><div class="track"><i data-w="${pct}"></i></div><span>${bd[st]}</span></div>`;
      }).join('');
      const barIO = new IntersectionObserver((e) => e.forEach(en => { if (en.isIntersecting) { $$('i', rb).forEach(i => i.style.width = i.dataset.w + '%'); barIO.disconnect(); } }), { threshold: .3 });
      barIO.observe(rb);
    }

    /* ---- animated counters ---- */
    const counters = $$('[data-count]');
    const cIO = new IntersectionObserver((e) => e.forEach(en => {
      if (!en.isIntersecting) return; const el = en.target; cIO.unobserve(el);
      const target = parseFloat(el.dataset.count), dec = +(el.dataset.dec || 0), suf = el.dataset.suffix || '';
      const isBig = target >= 1000; let t0 = null, dur = 1400;
      const step = (t) => { if (!t0) t0 = t; const k = Math.min(1, (t - t0) / dur); const e2 = 1 - Math.pow(1 - k, 3); let v = target * e2;
        el.textContent = (isBig ? Math.floor(v).toLocaleString() : v.toFixed(dec)) + suf; if (k < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    }), { threshold: .5 });
    counters.forEach(c => cIO.observe(c));

    /* ---- UGC grid ---- */
    const ug = $('#ugc-grid');
    if (ug && p.ugc) {
      const list = p.ugc.slice(0, 11);
      ug.innerHTML = list.map(s => `<a href="#reviews"><img src="${s}" alt="customer photo" loading="lazy"></a>`).join('')
        + `<a href="#reviews" class="more">+540<br>more</a>`;
    }

    /* ---- review wall + filters ---- */
    const wall = $('#review-wall'); const tb = $('#rev-toolbar'); const lm = $('#load-more');
    if (wall && STORE.reviews) {
      const all = STORE.reviews;
      let filter = 'all', shown = 6;
      const ago = (d) => d <= 1 ? 'yesterday' : d < 7 ? d + ' days ago' : d < 30 ? Math.floor(d / 7) + ' wk ago' : Math.floor(d / 30) + ' mo ago';
      const match = (r) => filter === 'all' ? true : filter === 'photo' ? r.imgs.length : (+filter === r.stars);
      function card(r) {
        const imgs = r.imgs.length ? `<div class="rc-imgs">${r.imgs.map(s => `<img src="${s}" alt="" loading="lazy">`).join('')}</div>` : '';
        const bought = (r.color || r.size) ? `<span class="bought">${r.color || ''}${r.color && r.size ? ' · ' : ''}${r.size ? r.size : ''}</span>` : '';
        return `<div class="rc">
          <div class="rc-top"><span class="rc-av">${(r.name[0] || 'A').toUpperCase()}</span>
            <div class="rc-id"><b>${r.name}</b><div class="vf">&#10003; Verified buyer</div></div>
            <span class="rc-date">${r.days != null ? ago(r.days) : ''}</span></div>
          <div class="rcstars">${'★'.repeat(r.stars)}${'☆'.repeat(5 - r.stars)}</div>
          ${r.title ? `<h5>${r.title}</h5>` : ''}
          <p>"${r.txt}"</p>${imgs}
          <div class="rc-foot"><span class="helpful">&#128077; Helpful${r.helpful ? ' (' + r.helpful + ')' : ''}</span>${bought}</div>
        </div>`;
      }
      function render() {
        const filtered = all.filter(match);
        wall.innerHTML = filtered.slice(0, shown).map(card).join('') || `<p style="color:var(--ink-soft)">No reviews match that filter.</p>`;
        if (lm) { lm.style.display = shown < filtered.length ? '' : 'none'; lm.textContent = `Show more reviews (${filtered.length - shown} left)`; }
      }
      const counts = { all: all.length, photo: all.filter(r => r.imgs.length).length, 5: all.filter(r => r.stars === 5).length, 4: all.filter(r => r.stars === 4).length };
      if (tb) {
        tb.innerHTML = [['all', 'All'], ['photo', 'With photos'], ['5', '5 ★'], ['4', '4 ★']]
          .map(([k, lab]) => `<button class="rev-chip${k === 'all' ? ' active' : ''}" data-f="${k}">${lab}<span class="c">${counts[k] || 0}</span></button>`).join('');
        $$('.rev-chip', tb).forEach(b => b.onclick = () => { filter = b.dataset.f; shown = 6; $$('.rev-chip', tb).forEach(x => x.classList.remove('active')); b.classList.add('active'); render(); });
      }
      if (lm) lm.onclick = () => { shown += 6; render(); };
      render();
    }

    /* ---- sticky add bar ---- */
    const sb = $('#stickybar'); const sbSize = $('#sb-size'); const sbAdd = $('#sb-add');
    if (sb && sbSize && sbAdd) {
      sbSize.innerHTML = '<option value="">Size</option>' + p.sizes.map(s => `<option value="${s}">${s}</option>`).join('');
      const buyEl = $('#pdp-add');
      const sObs = new IntersectionObserver((e) => e.forEach(en => sb.classList.toggle('show', !en.isIntersecting && scrollY > 700)), { threshold: 0 });
      if (buyEl) sObs.observe(buyEl);
      sbAdd.onclick = async () => {
        const size = sbSize.value || state.size;
        if (!size) { sbSize.style.borderColor = '#b3402f'; return; }
        sbSize.style.borderColor = '';
        const vid = findVariantId(state.color, size);
        if (!vid) { toast('Please select a size'); return; }
        await addToCart(vid, 1, []);
      };
    }

    /* ---- bundle buttons ---- */
    $$('.bundle-buy').forEach(b => b.onclick = async () => {
      const qty = +b.dataset.qty;
      if (!state.size) { const pdpGrid = document.querySelector('.pdp-grid'); if (pdpGrid) pdpGrid.scrollIntoView({ behavior: 'smooth' }); const sw = $('#size-warn'); if (sw) sw.classList.add('show'); return; }
      const vid = findVariantId(state.color, state.size);
      if (!vid) return;
      await addToCart(vid, qty, []);
    });
  }

  /* ---------------- home page render ---------------- */
  function initHome() {
    if (!STORE || !STORE.product) return;
    const p = STORE.product;
    const money = (n) => '£' + n.toFixed(2);
    // color rail
    const rail = $('#color-rail');
    if (rail) {
      rail.innerHTML = p.colors.map((c, i) => `
        <article class="rail-card reveal d${(i % 4) + 1}">
          <div class="ph"><span class="swatch" style="background:${c.hex}"></span><img src="${c.img}" alt="${c.label}"></div>
          <div class="meta"><h4>${c.label}</h4><span class="pr">${money(p.price)}</span></div>
        </article>`).join('');
      $$('.reveal', rail).forEach(el => io.observe(el));
    }
    // reviews
    const rg = $('#review-grid');
    if (rg && STORE.reviews) {
      rg.innerHTML = STORE.reviews.map(r => {
        const imgs = r.imgs.length ? `<div class="rev-imgs">${r.imgs.map(s => `<img src="${s}" alt="customer photo">`).join('')}</div>` : '';
        return `<div class="rev-card">
          <div class="stars">${'★'.repeat(r.stars)}${'☆'.repeat(5 - r.stars)}</div>
          <p>"${r.txt}"</p>${imgs}
          <div class="rev-who"><span class="rev-av">${(r.name[0] || 'A').toUpperCase()}</span>
            <span><b>${r.name}</b><br><span style="color:var(--ink-soft)">${r.country}</span></span>
            <span class="vf">&#10003; Verified</span>
          </div>
        </div>`;
      }).join('');
    }
    // stat fill from real data
    const sr = $('#stat-rating'); if (sr) sr.textContent = p.rating;
    const sc = $('#stat-reviews'); if (sc) sc.textContent = p.reviewsCount.toLocaleString();
    const ss = $('#stat-sold'); if (ss) ss.textContent = p.sold;
  }

  /* ---------------- scroll film (frame-scrubbed background) ---------------- */
  function initScrollFilm() {
    const canvas = document.getElementById('scroll-canvas');
    if (!canvas) return;
    const COUNT = (window.STORE_FILM && Number.isFinite(STORE_FILM.count)) ? STORE_FILM.count : 128;
    if (COUNT <= 0) {
      const stage = canvas.closest('.scroll-stage');
      if (stage) stage.style.display = 'none';
      return;
    }
    const ctx = canvas.getContext('2d', { alpha: false });
    const PATH = (i) => `/cdn/shop/files/frame_${String(i + 1).padStart(4, '0')}.jpg`;
    const frames = new Array(COUNT);
    let loaded = 0, current = -1, w = 0, h = 0, dpr = 1;

    function size() {
      dpr = Math.min(devicePixelRatio || 1, 2);
      w = innerWidth; h = innerHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      canvas.style.width = w + 'px'; canvas.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (current >= 0 && frames[current]) draw(current);
    }
    function draw(i) {
      const img = frames[i]; if (!img) return;
      const ir = img.width / img.height, cr = w / h;
      let dw, dh, dx, dy;
      if (ir > cr) { dh = h; dw = h * ir; } else { dw = w; dh = w / ir; }
      dx = (w - dw) / 2; dy = (h - dh) / 2;
      ctx.drawImage(img, dx, dy, dw, dh);
    }
    function load() {
      for (let i = 0; i < COUNT; i++) {
        const img = new Image();
        img.onload = () => { loaded++; if (i === 0) { current = 0; draw(0); } };
        img.src = PATH(i); frames[i] = img;
      }
    }
    let target = 0, shown = 0, raf = false;
    function onScrollFilm() {
      const max = document.documentElement.scrollHeight - innerHeight;
      const prog = max > 0 ? Math.min(1, Math.max(0, scrollY / max)) : 0;
      target = prog * (COUNT - 1);
      if (!raf) { raf = true; requestAnimationFrame(tick); }
    }
    function tick() {
      raf = false;
      shown += (target - shown) * 0.18;
      if (Math.abs(target - shown) < 0.01) shown = target;
      const i = Math.round(shown);
      if (i !== current && frames[i] && frames[i].complete) { current = i; draw(i); }
      if (Math.abs(target - shown) > 0.01) { raf = true; requestAnimationFrame(tick); }
    }
    addEventListener('resize', size);
    addEventListener('scroll', onScrollFilm, { passive: true });
    size(); load(); onScrollFilm();
  }

  /* ---------------- boot ---------------- */
  refreshCart();
  if (document.body.dataset.page === 'product') initProduct();
  if (document.body.dataset.page === 'home') { initHome(); initScrollFilm(); }
})();
